import reactImg from "../images/reactImg.png";
import nodeJs from "../images/nodeJs.png";
import expressJs from "../images/expressJs.png";
import mongoDB from "../images/mongoDB.png";
import sassImg from "../images/sassImg.png";
import materialUiImg from "../images/materialUiImg.png";
import javascriptImg from "../images/javascript.jpg";
import bootstrap from "../images/bootstrap.jpg";

const skillData = [
  {
    id: 1,
    domain: "webDev",
    category: "FrontEnd",
    language: "React Js",
    img: reactImg,
  },
  {
    id: 2,
    domain: "webDev",
    category: "FrontEnd",
    language: "Javascript",
    img: javascriptImg,
  },
  {
    id: 3,
    domain: "webDev",
    category: "FrontEnd",
    language: "SASS",
    img: sassImg,
  },
  {
    id: 4,
    domain: "webDev",
    category: "FrontEnd",
    language: "Material UI",
    img: materialUiImg,
  },
  {
    id: 5,
    domain: "webDev",
    category: "FrontEnd",
    language: "Bootstrap",
    img: bootstrap,
  },
  {
    id: 6,
    domain: "webDev",
    category: "BackEnd",
    language: "Node Js",
    img: nodeJs,
  },
  {
    id: 7,
    domain: "webDev",
    category: "BackEnd",
    language: "Express Js",
    img: expressJs,
  },
  {
    id: 8,
    domain: "webDev",
    category: "BackEnd",
    language: "Mongo DB",
    img: mongoDB,
  },
];

export default skillData;
